import { z } from "zod";

/**
 * Schema del formulario · valida campos individuales + cross-field
 * (fin >= inicio) en un solo lugar reutilizable por el form y los tests.
 */
export const datosGeneralesSchema = z
  .object({
    motivoPago: z.string().min(1, "Motivo de pago obligatorio").max(500),
    periodoServicioInicio: z.string().min(1, "Fecha inicio obligatoria"),
    periodoServicioFin: z.string().min(1, "Fecha fin obligatoria"),
    comentarios: z.string().max(1000).optional(),
    areaId: z.string().uuid({ message: "Selecciona un área" }),
  })
  .refine(
    (data) =>
      !data.periodoServicioInicio
      || !data.periodoServicioFin
      || data.periodoServicioFin >= data.periodoServicioInicio,
    {
      message: "La fecha fin debe ser igual o posterior al inicio",
      path: ["periodoServicioFin"],
    }
  );

export type DatosGeneralesFormValues = z.infer<typeof datosGeneralesSchema>;

/** Payload con la forma que espera el endpoint del backend. */
export interface DatosGeneralesInput {
  motivoPago: string;
  periodoServicioInicio: string;
  periodoServicioFin: string;
  comentarios: string | null;
  areaId: string;
}
